import { render } from "./needupload.vue?vue&type=template&id=4da13afa&scoped=true"
import script from "./needupload.vue?vue&type=script&lang=js"
export * from "./needupload.vue?vue&type=script&lang=js"

import "./needupload.vue?vue&type=style&index=0&id=4da13afa&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da13afa"]])

export default __exports__